import React, { useState } from 'react';
import { Cookie, Check } from 'lucide-react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Button } from '../components/ui/button';
import { Switch } from '../components/ui/switch';

const CookiesPage = () => {
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: true,
    marketing: false,
    preferences: true
  });

  const handleSave = () => {
    // Save cookie preferences
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    alert('Cookie preferences saved!');
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
              <Cookie className="w-6 h-6 text-emerald-600" />
            </div>
            <div>
              <h1 className="text-4xl font-bold text-gray-900">Cookie Policy</h1>
              <p className="text-gray-500">Last updated: January 1, 2025</p>
            </div>
          </div>
          
          <div className="prose prose-lg max-w-none mb-12">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">What Are Cookies?</h2>
              <p className="text-gray-600 mb-4">
                Cookies are small text files that are stored on your device when you visit a website. They help us provide you with a better experience by remembering your preferences and understanding how you use our site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Types of Cookies We Use</h2>
              
              <div className="space-y-6">
                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-lg font-semibold text-gray-900">Necessary Cookies</h3>
                    <Switch checked={preferences.necessary} disabled />
                  </div>
                  <p className="text-gray-600 text-sm">
                    These cookies are essential for the website to function properly. They enable basic features like page navigation and access to secure areas. The website cannot function properly without these cookies.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-lg font-semibold text-gray-900">Analytics Cookies</h3>
                    <Switch 
                      checked={preferences.analytics} 
                      onCheckedChange={(checked) => setPreferences({...preferences, analytics: checked})}
                    />
                  </div>
                  <p className="text-gray-600 text-sm">
                    These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our services.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-lg font-semibold text-gray-900">Marketing Cookies</h3>
                    <Switch 
                      checked={preferences.marketing} 
                      onCheckedChange={(checked) => setPreferences({...preferences, marketing: checked})}
                    />
                  </div>
                  <p className="text-gray-600 text-sm">
                    These cookies are used to track visitors across websites to display relevant advertisements. They help us measure the effectiveness of our marketing campaigns.
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-lg font-semibold text-gray-900">Preference Cookies</h3>
                    <Switch 
                      checked={preferences.preferences} 
                      onCheckedChange={(checked) => setPreferences({...preferences, preferences: checked})}
                    />
                  </div>
                  <p className="text-gray-600 text-sm">
                    These cookies allow the website to remember choices you make (such as your language or region) and provide enhanced, personalized features.
                  </p>
                </div>
              </div>

              <div className="mt-6">
                <Button onClick={handleSave} className="bg-emerald-500 hover:bg-emerald-600">
                  <Check className="w-4 h-4 mr-2" /> Save Preferences
                </Button>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">How to Control Cookies</h2>
              <p className="text-gray-600 mb-4">
                Most web browsers allow you to control cookies through their settings. You can:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>View cookies stored on your device</li>
                <li>Allow or block cookies</li>
                <li>Delete cookies at any time</li>
                <li>Browse in "private" or "incognito" mode</li>
              </ul>
              <p className="text-gray-600">
                Please note that blocking certain cookies may impact your experience on our website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Third-Party Cookies</h2>
              <p className="text-gray-600 mb-4">
                We may use third-party services that set their own cookies, including:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Google Analytics - for website analytics</li>
                <li>Social media platforms - for sharing functionality</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Updates to This Policy</h2>
              <p className="text-gray-600 mb-4">
                We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Us</h2>
              <p className="text-gray-600">
                If you have questions about our use of cookies, please contact us at:
                <br /><br />
                <strong>Email:</strong> privacy@toolsmetric.com
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CookiesPage;